<template>
  <div class="protocol-item-topic">
    <div class="func-section">
      <div
        class="search-hd"
        style="padding-top: 0"
      >
        <div class="btn-group">
          <el-form
            :inline="true"
            @submit.native.prevent
          >
            <el-form-item
              style="float: left"
              v-if="!isDeriveProtocol"
            >
              <el-button
                type="primary"
                @click="onAdd"
                :disabled="!protocolId"
              >
                <i class="el-icon-plus el-icon--left"></i>
                {{ $t('Common.com_add') }}
              </el-button>
            </el-form-item>
            <el-form-item
              style="float: left"
              v-if="!isDeriveProtocol"
            >
              <el-button
                @click="onImportTopic"
                :disabled="!protocolId"
              >
                <i class="icon icon-daoru"></i>
                {{ $t('dms_protocol_item_topic.kuai_su_dao_ru') }}
              </el-button>
            </el-form-item>
            <el-form-item
              style="float: left"
              v-if="isDeriveProtocol"
            >
              <el-button
                @click="onSettingTopic"
                :disabled="!protocolId"
                icon="el-icon-plus"
              >{{ $t('dms_protocol_item_topic.Topicshe_zhi') }}</el-button>
            </el-form-item>
            <el-form-item style="float: left">
              <el-button
                :disabled="!deleteVisible"
                @click="onDelete(selectedData)"
              >{{ $t('Common.com_delete') }}</el-button>
            </el-form-item>
            <!-- 导出 -->
            <!-- <el-form-item style="float: right; margin-right: 0;">
              <el-button
                class="table-set"
                @click="exportTableList"
              ><i class="icon icon-daochu"></i></el-button>
            </el-form-item> -->
            <!-- 配置项 -->
            <el-form-item style="float: right">
              <el-dropdown
                trigger="click"
                :hide-on-click="false"
                @visible-change="saveTableColumn"
              >
                <el-button
                  class="table-set"
                  icon="icon icon-tableset"
                ></el-button>
                <el-dropdown-menu
                  slot="dropdown"
                  class="custom-dropdown"
                >
                  <el-dropdown-item>
                    <el-checkbox
                      v-model="isAllColumn"
                      @change="setAllColumn"
                    >{{ $t('Common.com_sel_all') }}</el-checkbox>
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-for="(item, i) in tableColumn"
                    :key="i"
                  >
                    <el-checkbox
                      v-model="item.selected"
                      @change="formatTable"
                    >{{ item.columnName }}</el-checkbox>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </el-form-item>
            <el-form-item style="float: right">
              <search-input
                class="search"
                v-model="formSearch.search"
                @fetch="onFetch"
                :placeholder="$t('dms_protocol_item_topic.TopicmcTopbmTopicURL')"
              ></search-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <div class="table-bd">
      <custom-table
        :data="tableList"
        :column="tableColumn"
        @filter="filterChange"
        @sort="sortChange"
        :slots="['topicName', 'topicCode', 'action']"
        type="checkbox"
        v-model="selectedData"
        height="100%"
      >
        <template v-slot:topicName="scope">
          <el-button
            type="text"
            size="mini"
            @click="onDetail(scope.row.topicId)"
          >{{ scope.row.topicName }}</el-button>
        </template>
        <template v-slot:topicCode="scope">
          <span
            class="topic-code"
            @click="checkRelativeModelDetail(scope.row)"
          >{{ scope.row.topicCode }}</span>
        </template>
        <template v-slot:action="scope">
          <span>
            <el-button
              v-if="!isDeriveProtocol"
              type="text"
              size="mini"
              @click="onEdit(scope.row)"
            >{{ $t('Common.com_edit') }}</el-button>

            <el-button
              v-if="!isDeriveProtocol"
              type="text"
              size="mini"
              @click="onBind(scope.row)"
            >
              {{ $t('dms_protocol_item_topic.guan_lian_wu_mo_xing') }}
            </el-button>
            <el-button
              v-if="!scope.row.state && !isDeriveProtocol"
              type="text"
              size="mini"
              @click="onUpdateState(scope.row)"
            >{{ $t('Common.com_enable') }}</el-button>
            <el-button
              v-if="scope.row.state && !isDeriveProtocol"
              type="text"
              size="mini"
              @click="onUpdateState(scope.row)"
            >{{ $t('Common.com_disable') }}</el-button>
            <!-- 非衍生协议需要判断是否已经被禁用 -->
            <el-button
              v-if="!scope.row.state && !isDeriveProtocol"
              type="text"
              size="mini"
              @click="onDelete(scope.row)"
            >{{ $t('Common.com_delete') }}</el-button>
            <!-- 如果是衍生协议，则直接删除 -->
            <el-button
              v-if="isDeriveProtocol"
              type="text"
              size="mini"
              @click="onDelete(scope.row)"
            >{{ $t('Common.com_delete') }}</el-button>
          </span>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page
        :total="totalRows"
        :page="formSearch.pageNum"
        :size="formSearch.pageSize"
        @change="onPageChange"
      ></custom-page>
    </div>
    <!-- topic详情新增/编辑 dialog -->
    <topic-item-dialog
      v-if="showTopicDialog"
      @close="showTopicDialog = false"
      :protocolCode="info.protocolCode"
      :topicId="editModel.topicId"
      :model="dialogModel1"
      @success="getTableList"
    ></topic-item-dialog>
    <!-- 导入Topic dialog -->
    <sel-classify-dialog
      v-if="showTopicImportDialog"
      @close="showTopicImportDialog = false"
      :protocolCode="info.protocolCode"
      :protocolId="protocolId"
      @success="getTableList"
      :model="dialogModel2"
    ></sel-classify-dialog>
    <!-- Topic 设置 -->
    <topic-setting-dialog
      v-if="showTopicSettingDialog"
      @close="showTopicSettingDialog = false"
      :protocolCode="info.protocolCode"
      @success="getTableList"
      :model="dialogModel5"
    ></topic-setting-dialog>
    <!-- 关联物模型 dialog -->
    <topic-bind-model-dialog2
      v-if="showTopicBindDialog"
      @close="showTopicBindDialog = false"
      :protocolCode="info.protocolCode"
      :topicId="editModel.topicId"
      @success="getTableList"
      :model="dialogModel3"
      :width="dialogWidth"
    ></topic-bind-model-dialog2>
    <!-- topic详情预览 drawer -->
    <topic-detail-drawer
      v-if="showTopicDetailDialog"
      :visible.sync="showTopicDetailDialog"
      :id="curTopicId"
    ></topic-detail-drawer>
    <!-- 查看关联物模型 -->
    <check-relative-model-dialog
      v-if="showCheckRelativeModelDialog"
      @close="showCheckRelativeModelDialog = false"
      :model="dialogModel4"
      :protocolCode="info.protocolCode"
    ></check-relative-model-dialog>
    <div class="footer">
      <el-button @click="onCancel">{{ $t('Common.com_cancel') }}</el-button>
      <el-button @click="onBack">{{ $t('dms_protocol_item_topic.sybwmx') }}</el-button>
      <el-button
        type="primary"
        @click="onFinish"
      >{{ $t('Common.com_finish') }}</el-button>
      <!-- <el-button
        type="primary"
        @click="onStep"
      >下一页</el-button> -->
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import topicItemDialog from './topic_item_dialog.vue';
import topicDetailDrawer from './topic_detail_drawer.vue';
import selClassifyDialog from './protocol_import_topic_dialog.vue';
import topicSettingDialog from './protocol_topic_setting_dialog.vue';
import topicBindModelDialog2 from './topic_bind_model_dialog';
import checkRelativeModelDialog from './check_relative_model_dialog.vue';
import mixins from './mixins';

export default {
  mixins: [mixins],
  components: {
    topicItemDialog,
    selClassifyDialog,
    topicDetailDrawer,
    topicBindModelDialog2,
    checkRelativeModelDialog,
    topicSettingDialog,
  },
  props: {
    // productId: String,
    // protocolId: String,
    // productCode: String,
    // tslVersion: String,
    info: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    // 判断是否允许批量删除
    deleteVisible() {
      if (this.isDeriveProtocol) {
        return this.selectedData.length;
      } else {
        return this.selectedData.length && !this.selectedData.some(item => item.state);
      }
    },
    dialogWidth() {
      const windowWidth = window.innerWidth;
      const width = Math.max(windowWidth * 0.9, 1600);

      return [width, 'px'].join('');
    }
  },
  data() {
    return {
      tableCode: 'protocol_topic_list',
      tableList: [],
      totalRows: null,
      formSearch: {
        topicClass: '',
        pageSize: 30,
        pageNum: 1,
      },
      showTopicDialog: false,
      editModel: {},
      showTopicImportDialog: false,
      showTopicBindDialog: false,
      showTopicDetailDialog: false,
      showCheckRelativeModelDialog: false,
      showTopicSettingDialog: false,
      curTopicId: '',
      dialogModel1: {},
      dialogModel2: {},
      dialogModel3: {},
      dialogModel4: {},
      dialogModel5: {},
      protocolId: '',
      protocolCode: '',
      selectedData: [],
    };
  },
  methods: {
    // 取消
    onCancel: function () {
      this.$emit('cancel');
    },
    // 返回
    onBack: function () {
      this.$emit('back');
    },
    // 下一步
    onStep: function () {
      this.$emit('step', { name: 'model' });
    },
    // 完成
    onFinish: function () {
      this.clearTagByKeep('protocol_item');
      this.jump('/iot/protocol', {}, true);
    },
    initData() {
      const { protocolId, protocolCode } = this.info;
      this.protocolId = protocolId;
      this.protocolCode = protocolCode;
    },
    checkRelativeModelDetail(row) {
      this.dialogModel4 = {
        data: row,
        title: this.$t('dms_protocol_item_topic.ckglwmx'),
      };
      this.showCheckRelativeModelDialog = true;
    },
    exportTableList() {
      this.exportTable('TopicExport', {
        productCode: this.productCode,
      });
    },
    onFetch() {
      if (this.protocolId) {
        this.onPageChange({ page: 1 });
      }
    },
    onDetail(id) {
      this.curTopicId = id;
      this.showTopicDetailDialog = true;
    },
    onAdd() {
      this.dialogModel1 = {
        type: 'add',
        title: this.$t('dms_protocol_item_topic.xin_zengTopic'),
      };
      this.showTopicDialog = true;
    },
    onEdit(row) {
      // this.topicType = 'edit';
      this.dialogModel1 = {
        type: 'edit',
        title: this.$t('dms_protocol_item_topic.bian_jiTopic'),
        data: row,
      };
      this.editModel = row;
      this.showTopicDialog = true;
    },
    onUpdateState(row) {
      const openTpl = this.$t('dms_protocol_item_topic.nqdyqyxzdTopicm');
      const closeTpl = this.$t('dms_protocol_item_topic.nqdyjyxzdTopicm');
      const tips = row.state ? closeTpl : openTpl;
      this.$showConfirm(tips).then(() => {
        this.$postJSON(apis.TopicUpdateState, {
          topicId: row.topicId,
          state: row.state ? 0 : 1,
        }).then(() => {
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success',
          });
          this.getTableList();
        });
      });
    },
    onBind(row) {
      this.editModel = row;
      this.dialogModel3 = {
        title: this.$t('dms_protocol_item_topic.glwmxo', [row.topicCode]),
      };
      this.showTopicBindDialog = true;
    },
    onDelete(row) {
      const rows = Array.isArray(row) ? [...row] : [row];
      const tips = this.$t('dms_protocol_item_topic.nqdyscxzdTopicm');
      this.$showConfirm(tips).then(() => {
        const reqData = {
          protocolCode: this.protocolCode,
          topicIdList: rows.map(item => item.topicId),
        };
        this.$postJSON(apis.TopicDelete, reqData, true).then(() => {
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success',
          });
          this.getTableList();
        });
      });
    },
    onImportTopic() {
      this.dialogModel2 = {
        title: this.$t('dms_protocol_item_topic.dao_ruTopic'),
      };
      this.showTopicImportDialog = true;
    },
    onSettingTopic() {
      this.dialogModel5 = {
        title: this.$t('dms_protocol_item_topic.Topicshe_zhi'),
      };
      this.showTopicSettingDialog = true;
    },
    getTableList() {
      this.$getJSON(apis.TopicPage, {
        ...this.formSearch,
        protocolCode: this.protocolCode,
      }).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    update() {
      this.onPageChange({ page: 1 });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
  },
  mounted() {
    this.getTableColumn();
    this.initData();
    this.getTableList();
  },
};
</script>

<style lang="scss">
.protocol-item-topic {
  display: flex;
  flex-direction: column;
  height: 100%;
  .topic-code {
    cursor: pointer;
    text-decoration: underline;
  }
  .func-section {
    overflow: hidden;
    .el-form-item {
      margin-bottom: 0;
    }
  }
  .btn-group {
    float: left;
    width: 100%;
  }
  .topic-class {
    float: right;
  }
  .search {
    float: right;
  }
}
</style>
